import { AbstractControl, ValidatorFn } from '@angular/forms'
import parsePhoneNumber from 'libphonenumber-js'

export function phoneValidator(isOptional): ValidatorFn {
  return function validate(formControl: AbstractControl) {

    const hasLetterRegExp = /[a-zA-Z]/g
    if (hasLetterRegExp.test(formControl.value)) {
      return {
        phoneValidator: true
      }
    }

    const phoneNumber = parsePhoneNumber(formControl.value, 'CA')

    if (phoneNumber) {
      if (phoneNumber.isPossible()) {
        return null
      }

      return {
        phoneValidator: true
      }
    }

    if(isOptional && formControl.value) {
      return {
        phoneValidator: true
      }
    }

    if (!isOptional) {
      return {
        phoneValidator: true
      }
    }

  }
}
